{
  "title": "Чати",
  "description": "Класні, проєктні та особисті розмови.",
  "loading": "Завантаження…",
  "empty": {
    "title": "Розмов ще немає",
    "text": "Розпочніть особисту розмову з тим, кому вам дозволено писати."
  },
  "emptySearch": "Нічого не знайдено.",
  "selectThread": "Оберіть розмову, щоб почати читати.",
  "backToList": "Назад до розмов",
  "threadList": "Розмови",
  "sections": {
    "class": "Класи",
    "project": "Проєкти",
    "direct": "Особисті повідомлення"
  },
  "noMessages": "Повідомлень ще немає. Привітайтеся.",
  "noPreview": "Повідомлень ще немає",
  "unread_one": "{{count}} непрочитане",
  "unread_few": "{{count}} непрочитані",
  "unread_many": "{{count}} непрочитаних",
  "muted": "Без сповіщень",
  "mute": "Вимкнути сповіщення цієї розмови",
  "unmute": "Увімкнути сповіщення цієї розмови",
  "muteSaved": "Налаштування сповіщень збережено.",
  "participants_one": "{{count}} учасник",
  "participants_few": "{{count}} учасники",
  "participants_many": "{{count}} учасників",
  "realtime": {
    "reconnecting": "Відновлюємо зв'язок…",
    "live": "Наживо"
  },
  "composer": {
    "label": "Повідомлення",
    "placeholder": "Напишіть повідомлення…",
    "send": "Надіслати",
    "sending": "Надсилаємо…",
    "hint": "Enter — надіслати, Shift+Enter — новий рядок.",
    "mutedByStaff": "Вам обмежили право писати в цій розмові: читати можна, надсилати — ні."
  },
  "message": {
    "removed": "Повідомлення вилучено",
    "actions": "Дії з повідомленням",
    "delete": "Видалити повідомлення",
    "deleteConfirmTitle": "Видалити це повідомлення?",
    "deleteConfirmBody": "Воно залишиться на місці як «Повідомлення вилучено». Скасувати не можна.",
    "deleted": "Повідомлення видалено.",
    "report": "Поскаржитися",
    "you": "Ви"
  },
  "report": {
    "title": "Поскаржитися на повідомлення",
    "description": "Кожну скаргу переглядає адміністратор школи. Опишіть, що не так.",
    "quoted": "Повідомлення, на яке скаржитесь",
    "reason": "Причина",
    "reasons": {
      "abuse": "Цькування або образи",
      "inappropriate": "Недоречний вміст",
      "spam": "Спам",
      "other": "Інше"
    },
    "details": "Що ще варто знати адміністратору (необов'язково)",
    "detailsPlaceholder": "Додайте деталі…",
    "submit": "Надіслати скаргу",
    "sent": "Скаргу надіслано. Адміністратор її розгляне."
  },
  "newDm": {
    "button": "Нове повідомлення",
    "title": "Почати особисту розмову",
    "description": "Оберіть, кому хочете написати.",
    "search": "Пошук людей",
    "searchPlaceholder": "Шукати за іменем…",
    "empty": "Немає кого показати.",
    "pupilsOff": "Ця школа не дозволяє учням листуватися між собою приватно.",
    "start": "Почати розмову",
    "starting": "Починаємо…"
  },
  "cancel": "Скасувати",
  "roles": {
    "admin": "Адміністратор",
    "teacher": "Вчитель",
    "pupil": "Учень",
    "parent": "Батьки"
  },
  "unreadCard": {
    "title": "Непрочитані повідомлення",
    "empty": "Усе прочитано.",
    "total_one": "{{count}} непрочитане повідомлення",
    "total_few": "{{count}} непрочитані повідомлення",
    "total_many": "{{count}} непрочитаних повідомлень",
    "open": "Відкрити чати"
  },
  "loadOlder": "Показати давніші повідомлення"
}
